import ErrorIcon from "../../assets/icons/ErrorIcon.svg";
import ConnectedStatusOD from "../../assets/icons/ConnedtedStatusOD.svg";
import NotConnected from "../../assets/icons/NotConnected.svg";
import { domain_vizr } from "../../redux/constants/constants";
import {
  applicationBasedAnomaliesColumn,
  applicationBasedUsersColumn,
  locationBasedAnomaliesColumn,
  locationBasedApplicationColumn,
  locationBasedFailurePercentageColumn,
  locationBasedUsersColumn,
  userAnomaliesColumn,
  userBasedFailurePercentageColumn,
  applicationBasedFailurePercentageColumn,
  userDeviceColumns,
  userLocationColumns,
  cityBasedFailurePercentageColumn,
} from "./Popups/SysGuardPopupColumns";
import { isEmpty, isNull } from "lodash";
import { appendPopupFilters } from "./Popups/SysGuardApiHelper";
export const SYS_GUARD = "mdr-sysGuard";
export const SET_ALIAS_NAME = "SET_ALIAS_NAME";
export const SET_APPLICATION_NAME = "SET_APPLICATION_NAME";
export const SET_DOMAIN_NAME = "SET_DOMAIN_NAME";
export const SET_HOST_TYPE = "SET_HOST_TYPE";
export const SET_ENGINE = "SET_ENGINE";
export const SET_APPLICATION_NAME_LIST = "SET_APPLICATION_NAME_LIST";
export const RESET_SYS_GUARD = "RESET_SYS_GUARD";
export const FETCH_SYS_GUARD_DATA_SOURCE = "FETCH_SYS_GUARD_DATA_SOURCE";
export const FETCH_ALL_SYS_GUARD_DATA_SOURCES = "FETCH_ALL_SYS_GUARD_DATA_SOURCES";
export const SET_SYS_GUARD_DATASOURCE = "SET_SYS_GUARD_DATASOURCE";
export const SET_ALL_SYS_GUARD_DATASOURCES = "SET_ALL_SYS_GUARD_DATASOURCES";
export const SET_SYS_FROM_TIME_STAMP = "SET_SYS_FROM_TIME_STAMP";
export const SET_SYS_TO_TIME_STAMP = "SET_SYS_TO_TIME_STAMP";
export const SET_SYS_GUARD_TABLE_DATA = "SET_SYS_GUARD_TABLE_DATA";
export const CLEAR_SYS_GUARD_DATA = "CLEAR_SYS_GUARD_DATA";
export const SET_SYS_GUARD_PAGE_LOADER = "SET_SYS_GUARD_PAGE_LOADER";
export const GET_SYS_GUARD_USERS = "GET_SYS_GUARD_USERS";
export const GET_SYS_GUARD_LOCATION = "GET_SYS_GUARD_LOCATION";
export const GET_SYS_GUARD_APPLICATION = "GET_SYS_GUARD_APPLICATION";
export const SET_TOTAL_ELEMENTS = "SET_TOTAL_ELEMENTS";
export const GET_SYS_GUARD_HEADER_DATA = "GET_SYS_GUARD_HEADER_DATA";
export const SET_SYS_GUARD_HEADER_DATA = "SET_SYS_GUARD_HEADER_DATA";
export const GET_SYS_GUARD_POPUP_DATA = "GET_SYS_GUARD_POPUP_DATA";
export const SET_SYS_GUARD_POPUP_DATA = "SET_SYS_GUARD_POPUP_DATA";
export const SYS_GUARD_APPLICATION_NAMES_LIST = "SYS_GUARD_APPLICATION_NAMES_LIST";
export const SYS_GUARD_COUNTRIES_LIST = "SYS_GUARD_COUNTRIES_LIST";
export const SET_SYS_GUARD_POPUP_TOTAL_ELEMENTS =
  "SET_SYS_GUARD_POPUP_TOTAL_ELEMENTS";
export const SET_SYS_GUARD_SIDE_POPUP_DATA = "SET_SYS_GUARD_SIDE_POPUP_DATA";
export const GET_SYS_GUARD_SIDE_POPUP_DATA = "GET_SYS_GUARD_SIDE_POPUP_DATA";
export const SET_SYS_GUARD_DISTINCT_LOCATIONS =
  "SET_SYS_GUARD_DISTINCT_LOCATIONS";
export const GET_SYS_GUARD_DISTINCT_LOCATIONS =
  "GET_SYS_GUARD_DISTINCT_LOCATIONS";
export const GET_LOCATION_BASED_SYS_GUARD_USERS =
  "GET_LOCATION_BASED_SYS_GUARD_USERS";
export const GET_SYS_GUARD_CITY_DATA = "GET_SYS_GUARD_CITY_DATA";
export const GET_SYS_GUARD_FAILURE_LOCATIONS = "GET_SYS_GUARD_FAILURE_LOCATIONS";
export const SET_SYS_GUARD_CITY_DATA = "SET_SYS_GUARD_CITY_DATA";
export const SET_INCOGNITO = "SET_INCOGNITO";
export const CLEAR_SYS_GUARD_POPUP_DATA = "CLEAR_SYS_GUARD_POPUP_DATA";
export const CLEAR_SYS_GUARD_TABLE_DATA = "CLEAR_SYS_GUARD_TABLE_DATA";
export const SET_REPORT_INCIDENT_DETAILS = "SET_REPORT_INCIDENT_DETAILS";
export const SET_SELECTED_DATASOURCE_IDS = "SET_SELECTED_DATASOURCE_IDS";
export const SET_EDITING_DATASOURCE_ID = "SET_EDITING_DATASOURCE_ID";
export const SET_SYS_GUARD_SELECTED_APPLICATIONS = "SET_SYS_GUARD_SELECTED_APPLICATIONS";
export const SET_SYS_GUARD_APPLICATION_NAMES = "SET_SYS_GUARD_APPLICATION_NAMES";
export const SET_SYS_GUARD_SELECTED_COUNTRIES = "SET_SYS_GUARD_SELECTED_COUNTRIES";
export const SET_SYS_GUARD_COUNTRY_NAMES = "SET_SYS_GUARD_COUNTRY_NAMES";
export const GET_SYS_GUARD_FAILURE_LOCATIONS_USER = "GET_SYS_GUARD_FAILURE_LOCATIONS_USER";
export const GET_SYS_GUARD_FAILURE_LOCATIONS_APPLICATION = "GET_SYS_GUARD_FAILURE_LOCATIONS_APPLICATION";
export const MFALookUp = {
  true: "YES",
  false: "No",
};
export const GraphToolTip =
  "Access to users, roles, sites, files data through the Microsoft Graph API";
export const statusMapping = {
  Connected: ConnectedStatusOD,
  "Not Connected": NotConnected,
  Error: ErrorIcon,
};
export const isSysGuard = () => {
  const location = window.location.pathname;
  return location.includes("/mdr/sysguard");
};
export const getDatasourceWithType = (type) => {
  return `${domain_vizr}/tenant/dataSourceType/${type}`;
};
export const getAllSysGuardDataSources = () => {
  return `${domain_vizr}/sysguard/dataSources`;
};
export const fetchSysGuardUsersAPI = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  currentPage,
  pageSize
) => {
  return `${domain_vizr}/sysguard/users?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&page=${currentPage}&size=${pageSize}`;
};
export const fetchSysGuardLocationData = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  currentPage,
  pageSize
) => {
  return `${domain_vizr}/sysguard/locations?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&page=${currentPage}&size=${pageSize}`;
};

export const fetchSysGuardApplicationAPI = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  pageSize,
  currentPage
) => {
  return `${domain_vizr}/sysguard/applications?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&page=${currentPage}&size=${pageSize}`;
};

export const fetchSysGuardUserLocationApi = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
  filters,
  loc,
) => {
  let url =
    `${domain_vizr}/sysguard/user/locationSummary` +
    `?fromTimeStamp=${fromTimeStamp}` +
    `&toTimeStamp=${toTimeStamp}` +
    `&dataSourceId=${dataSourceId}` +
    `&actorId=${actorId}` +
    `&page=${currentPage}` +
    `&size=${pageSize}`;

  return appendPopupFilters(url, loc, filters);
};


export const fetchSysGuardUserDeviceApi = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
  filters,
  loc,
) => {
  let url =
    `${domain_vizr}/sysguard/user/deviceSummary` +
    `?fromTimeStamp=${fromTimeStamp}` +
    `&toTimeStamp=${toTimeStamp}` +
    `&dataSourceId=${dataSourceId}` +
    `&actorId=${actorId}` +
    `&page=${currentPage}` +
    `&size=${pageSize}`;

  return appendPopupFilters(url, loc, filters);
};

export const fetchSysGuardUserAnomaliesApi = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
  filters,
  loc,
) => {
  let url =
    `${domain_vizr}/sysguard/user/anomalies` +
    `?fromTimeStamp=${fromTimeStamp}` +
    `&toTimeStamp=${toTimeStamp}` +
    `&dataSourceId=${dataSourceId}` +
    `&actorId=${actorId}` +
    `&page=${currentPage}` +
    `&size=${pageSize}`;

  return appendPopupFilters(url, loc, filters);
};

export const fetchSysGuardUserApplicationApi = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
  filters,
  loc,
) => {
  let url =
    `${domain_vizr}/sysguard/user/appsSummary` +
    `?fromTimeStamp=${fromTimeStamp}` +
    `&toTimeStamp=${toTimeStamp}` +
    `&dataSourceId=${dataSourceId}` +
    `&actorId=${actorId}` +
    `&page=${currentPage}` +
    `&size=${pageSize}`;

  return appendPopupFilters(url, loc, filters);
};

export const fetchSidePopupData = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  location
) => {
  return `${domain_vizr}/sysguard/user/counts?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&actorId=${actorId}&groupBy=${location}`;
};

export const fetchUserBasedDevicesCount = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId
) => {
  return `${domain_vizr}/sysguard/user/deviceSummaryCount?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&actorId=${actorId}`
}

export const fetchUserAnomaliesSidePopupData = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId
) => {
  return `${domain_vizr}/sysguard/user/anomaliesCount?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&actorId=${actorId}`;
};

export const fetchSysGuardUserDistinctLocations = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId
) => {
  return `${domain_vizr}/sysguard/user/distinctLocations?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&actorId=${actorId}`;
};

export const fetchSysGuardFailureLocations = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  country
) => {
  return `${domain_vizr}/sysguard/location/failure/coordinates?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&country=${country}`;
}

export const fetchSysGuardCityFailureLocations = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  country,
  city
) => {
  return `${domain_vizr}/sysguard/location/failure/coordinates?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&country=${country}&city=${city}`;
}

export const fetchSysGuardFailureUserLocations = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
) => {
  return `${domain_vizr}/sysguard/user/failure/coordinates?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&actorId=${actorId}`;
};

export const fetchSysGuardFailureApplicationLocations = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  application,
) => {
  return `${domain_vizr}/sysguard/application/failure/coordinates?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&applicationName=${application}`;
};



export const fetchSysGuardLocationBasedUsers = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
  filters,
  loc,
) => {
  let url =
    `${domain_vizr}/sysguard/location/userSummary` +
    `?fromTimeStamp=${fromTimeStamp}` +
    `&toTimeStamp=${toTimeStamp}` +
    `&dataSourceId=${dataSourceId}` +
    `&country=${country}` +
    `&page=${currentPage}` +
    `&size=${pageSize}`;

  return appendPopupFilters(url, loc, filters);
};

export const fetchSysGuardCityBasedUsers = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
) => {
  return `${domain_vizr}/sysguard/location/userSummary?toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&fromTimeStamp=${fromTimeStamp}&country=${country}&city=${city}&page=${currentPage}&size=${pageSize}`;
}

export const fetchSysGuardApplicationBasedUsers = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
  filters,
  loc,
) => {
  let url =
    `${domain_vizr}/sysguard/application/userSummary` +
    `?fromTimeStamp=${fromTimeStamp}` +
    `&toTimeStamp=${toTimeStamp}` +
    `&dataSourceId=${dataSourceId}` +
    `&appName=${application}` +
    `&page=${currentPage}` +
    `&size=${pageSize}`;

  return appendPopupFilters(url, loc, filters);
};

export const fetchSysGuardApplicationBasedAnomalies = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
  filters,
  loc,
) => {
  let url =
    `${domain_vizr}/sysguard/application/anomalies` +
    `?fromTimeStamp=${fromTimeStamp}` +
    `&toTimeStamp=${toTimeStamp}` +
    `&dataSourceId=${dataSourceId}` +
    `&appName=${application}` +
    `&page=${currentPage}` +
    `&size=${pageSize}`;

  return appendPopupFilters(url, loc, filters);
};

export const fetchSysGuardLocationBasedAnomalies = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
  filters,
  loc,
) => {
  let url =
    `${domain_vizr}/sysguard/location/anomalies` +
    `?fromTimeStamp=${fromTimeStamp}` +
    `&toTimeStamp=${toTimeStamp}` +
    `&dataSourceId=${dataSourceId}` +
    `&country=${country}` +
    `&page=${currentPage}` +
    `&size=${pageSize}`;

  return appendPopupFilters(url, loc, filters);
};

export const fetchSysGuardCityBasedAnomalies =(
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
) => {
  return `${domain_vizr}/sysguard/location/anomalies?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&country=${country}&city=${city}&page=${currentPage}&size=${pageSize}`;
}

export const fetchSysGuardLocationBasedApplications = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country
) => {
  return `${domain_vizr}/sysguard/location/applications?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&country=${country}&page=${currentPage}&size=${pageSize}`;
};

export const fetchSysGuardCityBasedApplications = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
  filters,
  loc,
) => {
  let url =
    `${domain_vizr}/sysguard/location/applications` +
    `?fromTimeStamp=${fromTimeStamp}` +
    `&toTimeStamp=${toTimeStamp}` +
    `&dataSourceId=${dataSourceId}` +
    `&country=${country}` +
    `&city=${city}` +
    `&page=${currentPage}` +
    `&size=${pageSize}`;

  return appendPopupFilters(url, loc, filters);
};

export const fetchSysGuardCityFailureAssetsApi = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application,
  city,
) => {
  return `${domain_vizr}/sysguard/location/failureSummary?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&country=${country}&city=${city}&page=${currentPage}&size=${pageSize}`;
};

export const fetchSysGuardFailureAssetsApi = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
) => {
  return `${domain_vizr}/sysguard/location/failureSummary?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&country=${country}&page=${currentPage}&size=${pageSize}`;
};

export const fetchSysGuardUserBasedFailurePercentage = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
) => {
  return `${domain_vizr}/sysguard/users/failureSummary?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&actorId=${actorId}&page=${currentPage}&size=${pageSize}`;
};

export const fetchSysGuardApplicationBasedFailurePercentage = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId,
  pageSize,
  currentPage,
  country,
  application
) => {
  return `${domain_vizr}/sysguard/application/failureSummary?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&applicationName=${application}&page=${currentPage}&size=${pageSize}`;
};

export const fetchApplicationBasedUserCounts = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  application
) => {
  return `${domain_vizr}/sysguard/application/userCount?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&appName=${application}`
}

export const fetchLocationAnomaliesCount = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  country
) => {
  return `${domain_vizr}/sysguard/location/anomaliesCount?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&country=${country}`;
};

export const fetchCityAnomaliesCount = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  country,
  city
) => {
  return `${domain_vizr}/sysguard/location/anomaliesCount?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&country=${country}&city=${city}`;
}

export const fetchLocationBasedApplications = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  country
) => {
  return `${domain_vizr}/sysguard/user/counts?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&country=${country}&groupBy=application`;
};

export const fetchCityBasedApplications = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  country,
  city
) => {
  return `${domain_vizr}/sysguard/user/counts?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&country=${country}&city=${city}&groupBy=application`;
}

export const fetchLocationBasedFailures = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  country
) => {
  return `${domain_vizr}/sysguard/failure/reasons?viewType=LOCATION&dataSourceId=${dataSourceId}&fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&country=${country}`;
};

export const fetchCityBasedFailures = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  country,
  city
) => {
  return `${domain_vizr}/sysguard/failure/reasons?viewType=LOCATION&dataSourceId=${dataSourceId}&fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&country=${country}&city=${city}`;
};


export const fetchUserBasedFailurePercentage = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  actorId
) => {
  return `${domain_vizr}/sysguard/failure/reasons?viewType=USER&dataSourceId=${dataSourceId}&fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&actorId=${actorId}`;
};

export const fetchApplicationBasedFailurePercentage = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  application
) => {
  return `${domain_vizr}/sysguard//failure/reasons?viewType=APPLICATION&dataSourceId=${dataSourceId}&fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&applicationName=${application}`;}

export const fetchCityLevelInformation = (fromTimeStamp, toTimeStamp, dataSourceId, countryCode, currentPage, pageSize) => {
  return `${domain_vizr}/sysguard/locations/cities?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&page=${currentPage}&size=${pageSize}&countryName=${countryCode}`;
}
export const fetchApplicationAnomaliesCount = (
  fromTimeStamp,
  toTimeStamp,
  dataSourceId,
  application
) => {
  return `${domain_vizr}/sysguard/application/anomaliesCount?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&dataSourceId=${dataSourceId}&appName=${application}`
}

export const getSysGuardApplicationNames = (dataSourceId, fromTimeStamp, toTimeStamp, dataSet) => {
  return `${domain_vizr}/sysguard/${dataSet}?dataSourceId=${dataSourceId}&fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`;
}

export const fetchCityCoordinates = (city, countryCode) => {
  return `https://nominatim.openstreetmap.org/search?city=${city}&countrycodes=${countryCode}&format=json`;
}

export const getUniqueUsersList = (dataSourceId) => {
  return `${domain_vizr}/sysguard/user/distinct?dataSourceId=${dataSourceId}`
};

export const CREATE_JIRA_INCIDENT = "CREATE_JIRA_INCIDENT";

export const reportToJira = (alertId, dataSourceId) => {
  return `${domain_vizr}/jira/SIR/createIncident?alertId=${alertId}&dataSourceId=${dataSourceId}`;
}

export const calculatePercentage = (part, total) => {
  if (!total || total === 0) return 0;
  const percentage = (part / total) * 100;
  return percentage === 0 ? 0 : Math.round(percentage);
};

export const Content_Paths = [
  "/mdr/sysguard/content/Users",
  "/mdr/sysguard/content/Locations",
  "/mdr/sysguard/content/Applications",
];

export const countryWithFlagTableLocations = [
  "locationBasedUsers",
  "locationBasedAnomalies",
  "locationBasedApplications",
  "cityBasedUsers",
  "cityBasedAnomalies",
  "cityBasedApplications",
];

export const cityBasedLocations = [
  "cityBasedUsers",
  "cityBasedAnomalies",
  "cityBasedApplications",
]
export const titleWithCounts = [
  "locationBasedApplications",
  "cityBasedApplications",
  "locationBasedUsers",
  "cityBasedUsers",
  "userApplications",
  "userLocations",
  "applicationBasedUsers",
  "totalDevices",
];
export const applicationPopupMainTitleLocations = [
  "applicationBasedUsers",
  "applicationBasedAnomalies",
];
export const customBarChatLocations = [
  "locationBasedApplications",
  "cityBasedApplications",
  "userApplications",
];
export const sysGuardPopupTitles = {
  userLocations: "Location Based Access",
  userDevices: "Devices By User",
  totalDevices: "Devices",
  userApplications: "Applications",
  locationBasedUsers: "Location - Users",
  cityBasedUsers: "City - Users",
  locationBasedAnomalies: "Location - Anomalies",
  cityBasedAnomalies: "City - Anomalies",
  locationBasedApplications: "Location - Applications",
  cityBasedApplications: "City - Applications",
  applicationBasedUsers: "Application - Users",
  applicationBasedAnomalies: "Application - Anomalies",
  locationBasedFailurePercentage: "Location - Failed Attempts",
  cityBasedFailurePercentage: "City - Failed Attempts",
  userBasedFailurePercentage: "User - ",
  applicationBasedFailurePercentage: "Application - Failed Attempts",
};
export const sysGuardTitleNumbers = {
  userLocations: "locations",
  userDevices: "noOfDeviceAnomalies",
  totalDevices: "totalNoOfDevices",
  userAnomalies: "behavioralAnomaly",
  locationBasedUsers: "numberOfUsers",
  cityBasedUsers: "numberOfUsers",
  applicationBasedUsers: "numberOfUsers",
  locationBasedAnomalies: "locationAnomalies",
  cityBasedAnomalies: "locationAnomalies",
  locationBasedApplications: "applicationInUse",
  cityBasedApplications: "applicationInUse",
  applicationBasedAnomalies: "applicationAnomalies",
  locationBasedFailurePercentage: "failurePercentage",
  cityBasedFailurePercentage: "failurePercentage",
  userBasedFailurePercentage: "failurePercentage",
  applicationBasedFailurePercentage: "failurePercentage",
};
export const sysGuardSubHeadings = {
  userLocations: "Access Location:",
  userApplications: "User Applications:",
  locationBasedUsers: "Users:",
  cityBasedUsers: "Users:",
  locationBasedAnomalies: "Anomalies:",
  cityBasedAnomalies: "Anomalies:",
  totalDevices: "Total Devices:",
  locationBasedApplications: "Application:",
  cityBasedApplications: "Application:",
  applicationBasedUsers: "Users: "
};
export const sysGuardTableColumnMappings = {
  userLocations: userLocationColumns,
  userDevices: userDeviceColumns,
  totalDevices: userDeviceColumns,
  userAnomalies: userAnomaliesColumn,
  locationBasedUsers: locationBasedUsersColumn,
  cityBasedUsers: locationBasedUsersColumn,
  locationBasedAnomalies: locationBasedAnomaliesColumn,
  cityBasedAnomalies: locationBasedAnomaliesColumn,
  locationBasedApplications: locationBasedApplicationColumn,
  cityBasedApplications: locationBasedApplicationColumn,
  locationBasedFailurePercentage: locationBasedFailurePercentageColumn,
  cityBasedFailurePercentage: cityBasedFailurePercentageColumn,
  userBasedFailurePercentage: userBasedFailurePercentageColumn,
  applicationBasedFailurePercentage: applicationBasedFailurePercentageColumn,
  applicationBasedUsers: applicationBasedUsersColumn,
  applicationBasedAnomalies: applicationBasedAnomaliesColumn,
};
export const threatLevelLookup = {
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low",
  NONE: "No Risk"
};

export const SET_SYS_GUARD_ALERT_INFO_DATA = "SET_SYS_GUARD_ALERT_INFO_DATA";
export const CLEAR_SYS_GUARD_ALERT_INFO_DATA = "CLEAR_SYS_GUARD_ALERT_INFO_DATA";
export const sysGuardAlertInfoDataColumns = ["locationBasedAnomalies", "userAnomalies", "applicationBasedAnomalies", "cityBasedAnomalies"];

export const maskedUsernameLoc= ["locationBasedAnomalies", "applicationBasedUsers", "applicationBasedAnomalies", "cityBasedAnomalies"];

export const unknownUser = (value, isIncognito) => {
  return isEmpty(value) || isNull(value) ? "Unknown" : value;
}

export const largeMapMarkers = ["userLocation", "dashboardPopup"];
export const sysGuardAllowedDataSources = ["GOOGLEWORKSPACE", "ENTRA", "MICROSOFTAD"];

export const SET_EXPANDED_USERS_DASHBOARD_DATA = "SET_EXPANDED_USERS_DASHBOARD_DATA";
export const GET_EXPANDED_USERS_DASHBOARD_DATA = "GET_EXPANDED_USERS_DASHBOARD_DATA";
export const SET_SYS_GUARD_ALERT_COMMENT = "SET_SYS_GUARD_ALERT_COMMENT";
export const DISPLAY_SYS_GUARD_ALERT_COMMENT = "DISPLAY_SYS_GUARD_ALERT_COMMENT";
export const SAVE_SYS_GUARD_COMMENT = "SAVE_SYS_GUARD_COMMENT";
export const SET_SYS_GUARD_ALERT_STATUS = "SET_SYS_GUARD_ALERT_STATUS";
export const OPEN_SYS_GUARD_SNACKBAR = "OPEN_SYS_GUARD_SNACKBAR";
export const REPORT_INCIDENT_SUCCESSFUL = "REPORT_INCIDENT_SUCCESSFUL";
export const REPORT_INCIDENT_FAILED = "REPORT_INCIDENT_FAILED";
export const reportIncidentFailed = "Failed to Report Incident";
export const SET_SYS_GUARD_THREAT_PROBABILITIES = "SET_SYS_GUARD_THREAT_PROBABILITIES";
export const GET_UNIQUE_USER_LIST = "GET_UNIQUE_USER_LIST";
export const SET_UNIQUE_USER_LIST = "SET_UNIQUE_USER_LIST";
export const SET_SELECTED_USER = "SET_SELECTED_USER";
export const SET_SELECTED_MFA = "SET_SELECTED_MFA";
export const SET_SELECTED_RISK_FACTOR = "SET_SELECTED_RISK_FACTOR";
export const CLEAR_SYS_GUARD_FILTERS = "CLEAR_SYS_GUARD_FILTERS";
export const SET_SYS_GUARD_TABLE_LOADER = "SET_SYS_GUARD_TABLE_LOADER";
export const SET_CITY_TABLE_DATA = "SET_CITY_TABLE_DATA";
export const FETCH_CITY_TABLE_DATA = "FETCH_CITY_TABLE_DATA";
export const SET_CITY_LEVEL_TOTAL_ELEMENTS = "SET_CITY_LEVEL_TOTAL_ELEMENTS";
export const SET_COUNTRY_NAME = "SET_COUNTRY_NAME";
//NLP chatbot
export const FETCH_CHATBOT_RESPONSE = "FETCH_CHATBOT_RESPONSE";
export const SET_CHATBOT_RESPONSE = "SET_CHATBOT_RESPONSE";
export const CLEAR_CHATBOT = "CLEAR_CHATBOT";
export const SET_CHATBOT_LOADER = "SET_CHATBOT_LOADER";
export const getChatbotResponseAPI = () => {
  return `${domain_vizr}/nlp/convert`;
}
export const saveChatBotAPI = `${domain_vizr}/nlp/chat/upload`;
export const SAVE_CHAT_BOT_CHAT = "SAVE_CHAT_BOT_CHAT";

export const noSecondTitleLocations = ["locationBasedFailurePercentage", "userBasedFailurePercentage", "applicationBasedFailurePercentage", "cityBasedFailurePercentage"];

export const SAVE_CHATBOT_MESSAGES = "SAVE_CHATBOT_MESSAGES";
export const SET_CHATBOT_UNREAD = "SET_CHATBOT_UNREAD";
export const FETCH_USER_TYPE_LIST = "FETCH_USER_TYPE_LIST";
export const SET_USER_TYPE_LIST = "SET_USER_TYPE_LIST";
export const fetchUserTypesListAPI = () => {
  return `${domain_vizr}/sysguard/userTypes`
}
export const SET_SELECTED_USER_TYPE_LIST = "SET_SELECTED_USER_TYPE_LIST";
